// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from "@generouted/react-router/client";

export type Path =
  | `/`
  | `/agent-connect`
  | `/auth`
  | `/checkout`
  | `/desktop-connect`
  | `/desktop-return`
  | `/desktop-sign-in`
  | `/download`
  | `/flashcard`
  | `/home`
  | `/quiz`
  | `/settings`
  | `/summary`
  | `/transcript`
  | `/translate`;

export type Params = {};

export type ModalPath = never;

export const { Link, Navigate } = components<Path, Params>();
export const { useModals, useNavigate, useParams } = hooks<
  Path,
  Params,
  ModalPath
>();
export const { redirect } = utils<Path, Params>();
